import { useEffect } from 'react';
import { useSelector } from 'react-redux';

/**
 * Sets table product filter based on the table product type search param

 * @param tableProductFilter table filters stateful value, and a function to update it
 * @param paramType product type search param
 */
export const useInitProductFilterBasedOnTypeParam = (
  tableProductFilter,
  paramType,
) => {
  const { products } = useSelector((state) => state.products);
  const [selectedProductId, setSelectedProductId] = tableProductFilter;
  const shouldSetProductIdOnProductType =
    products && !selectedProductId && paramType;

  useEffect(() => {
    if (shouldSetProductIdOnProductType)
      setSelectedProductId(
        products?.find((product) => product?.name?.toLowerCase() === paramType)
          ?.id,
      );
  }, [products, paramType, selectedProductId]);
};
